import React from 'react';
import classNames from 'classnames';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import Icon from '../../common/components/Icon';
import Locking from './Locking';

const DragHandle = SortableHandle(() => <Icon icon="arrows" />);

const Group = ({
	locking,
	activeLockingId,
	collapsed,
	duplicationActive,
	onClick,
	onToggle
}) => {
	const isActive = locking.locking_id === activeLockingId;

	const classes = classNames('group', {
		'group--active': isActive,
		'group--duplication-active': duplicationActive
	});
	const collection = locking.locking_id;

	const hasChildren = locking.children;

	const arrowIcon = collapsed
		? <Icon icon="arrow-bottom" />
		: <Icon icon="arrow-top" />;

	return (
		<div className={classes}>
			<div className="group__header" onClick={() => onClick(locking)}>
				<div className="group__action group__drag-drop">
					<DragHandle />
				</div>
				<div className="group__folder-icon">
					<Icon icon="folder" />
				</div>
				{locking.name}
				<div
					className="group__action group__arrow-top-icon"
					onClick={event => {
						event.stopPropagation();
						onToggle();
					}}
				>
					{arrowIcon}
				</div>
			</div>
			<div className="group__lockings">
				{hasChildren &&
					!collapsed &&
					locking.children.map((locking, index) => {
						const isActive = locking.locking_id === activeLockingId;
						return (
							<Locking
								key={locking.locking_id}
								id={locking.locking_id}
								locking={locking}
								active={isActive}
								index={index}
								collection={collection}
								onClick={onClick}
							/>
						);
					})}
			</div>
		</div>
	);
};

export default SortableElement(Group);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/Group.js